import type { FormRegister } from '@fv/client-core'
import type {
  DeepPartial,
  HazardousDetailFormModel,
  LegacyReadOnlyDetail,
  LoadHandlingUnit,
  LoadItem,
  MakeOptional,
  PropsWithClassName,
} from '@fv/client-types'
import type { LoadLocationDto } from '@fv/models'

import type { RadioFieldOption } from '@/components/inputs/RadioField'

export type HandlingUnitType = 'single' | 'multi'
export type LoadStep = 'quoting' | 'booking'
export type ItemStop = Pick<LoadLocationDto, 'sequence' | 'stopType'> & {
  label: string
}
export type LoadItemFormModel = DeepPartial<
  Omit<LoadItem, 'hazardous'> & {
    hazardous?: HazardousDetailFormModel
    fullNmfc?: string
    isHazardous?: boolean
  }
> & {
  _id: string
}

// TODO
// There's lots of dancing around hazaroud being an array on the server and a single item on the client
// the server needs to be changed to have a single hazardous item in its schema
// but its exposed to the external API
export type LoadHandlingUnitFormModel = LoadItemFormModel &
  // get rid of load item properties and take them from LoadItemFormModel instead
  DeepPartial<
    Omit<LoadHandlingUnit, 'contains' | keyof LoadItem> & {
      readOnly?: LegacyReadOnlyDetail
      handlingUnitType?: HandlingUnitType
    }
  > & {
    contains?: LoadItemFormModel[]
  }

export type HandlingUnitFormUpdate = Omit<LoadHandlingUnitFormModel, '_id'>
export type ItemFormUpdate = MakeOptional<LoadItemFormModel, '_id'>

export type ChangeFn = (v: HandlingUnitFormUpdate) => void
export type ItemChangeFn = (v: ItemFormUpdate) => void

export type FormProps = {
  value: LoadHandlingUnitFormModel
  onChange: ChangeFn
}

export type ItemFieldProps = PropsWithClassName<{
  label?: string
  register: FormRegister<LoadItemFormModel>
}>
export type HandlingUnitFieldProps = Omit<ItemFieldProps, 'register'> & {
  register: FormRegister<LoadHandlingUnitFormModel>
}

export type DetailedItemFieldProps = ItemFieldProps & {
  value: LoadHandlingUnitFormModel
  onChange: ItemChangeFn
}
export type DetailedFieldProps = HandlingUnitFieldProps & {
  value: LoadHandlingUnitFormModel
  onChange: ChangeFn
}

export const unitTypeOptions: Array<RadioFieldOption<HandlingUnitType>> = [
  { label: 'Same commodity unit(s)', value: 'single' },
  { label: 'Multi-commodity unit(s)', value: 'multi' },
]

export type FormLayoutProps = {
  register: FormRegister<LoadHandlingUnitFormModel>
  value: LoadHandlingUnitFormModel
  onChange: ChangeFn
}
